import { IAssistantsBackendRequestDto, IAssistantsBackendResponse } from "../interfaces/IAssistantsBackend";

export const assistantsMapper = {
    toDto: (values: any): IAssistantsBackendRequestDto => {
        return {
            name: values.name,
            description: values.description,
            service_id: values.service_id.value,
            systemPrompt: values.systemPrompt,
            welcomeMessage: values.welcomeMessage,
            temperature: values.temperature !== '' ? Number(values.temperature) : undefined,
            topP: values.topP !== '' ? Number(values.topP) : undefined,
            maxTokens: values.maxTokens !== '' ? Number(values.maxTokens) : undefined,
            avatar: values.avatar,
            icon: values.icon,
            color: values.color,
            visibility: typeof values.visibility === 'object' ? values.visibility?.value : values.visibility,
            isPublic: values.isPublic,
            allowHistory: values.allowHistory,
            allowImages: values.allowImages,
            allowAudio: values.allowAudio,
            allowFileUpload: values.allowFileUpload,
            maxMessagesPerDay: values.maxMessagesPerDay !== '' ? Number(values.maxMessagesPerDay) : undefined,
            maxContextMessages: values.maxContextMessages !== '' ? Number(values.maxContextMessages) : undefined,
            assignedSkills: values.assignedSkills 
                ? Object.keys(values.assignedSkills).filter(key => values.assignedSkills[key]) 
                : [],
            metadata: values.metadata,
        };
    },
    toDomain: (item: IAssistantsBackendResponse): any => {
        return {
            id: item.id,
            name: item.name,
            description: item.description,
            serviceId: item.service?.id || item.service_id,
            serviceName: item.service?.name,
            systemPrompt: item.systemPrompt,
            welcomeMessage: item.welcomeMessage,
            temperature: item.temperature,
            topP: item.topP,
            maxTokens: item.maxTokens,
            avatar: item.avatar,
            icon: item.icon,
            color: item.color,
            visibility: item.visibility,
            isPublic: item.isPublic,
            allowHistory: item.allowHistory,
            allowImages: item.allowImages,
            allowAudio: item.allowAudio,
            allowFileUpload: item.allowFileUpload,
            maxMessagesPerDay: item.maxMessagesPerDay,
            maxContextMessages: item.maxContextMessages,
            assignedSkills: item.assignedSkills?.reduce((acc: any, skill: any) => {
                acc[skill.skillId || skill.id || skill] = true;
                return acc;
            }, {}) || {},
            metadata: item.metadata,
        };
    }
};
